<div class="file-pond">
  <file-pond
  #myPond
  [options]="pondOptions"
  (onaddfile)="pondHandleAddFile($event)"
  (onactivatefile)="pondHandleActivateFile($event)"
  (onremovefile)="pondHandleRemoveFile($event)"
  >
</file-pond>
</div>


